import React from 'react';
import { Route, Redirect } from 'react-router-dom';

const PrivateRoute = ({
  component: Component,
  render,
  path,
  authenticated,
  templates,
  template,
  ...rest
}) => {
  // Check to see if the current template have access to this route.
  // if the 'templates' array is empty, the route is accessible for all templates.
  const isAllowed =
    templates.includes(template) ||
    templates.length === 0 ||
    process.env.NODE_ENV === 'development';

  return (
    <Route
      path={path}
      {...rest}
      render={(props) => {
        if (authenticated) {
          if (Component) {
            if (isAllowed) {
              return <Component {...props} />;
            } else {
              return <Redirect to={{ pathname: '/', state: { from: path } }} />;
            }
          } else if (render) {
            if (isAllowed) {
              return render(props);
            } else {
              return <Redirect to={{ pathname: '/', state: { from: path } }} />;
            }
          }
        } else {
          // console.log(3, path, authenticated);
          return (
            <Redirect to={{ pathname: '/auth/login', state: { from: path } }} />
          );
        }
        // authenticated ? ( Component ? ( <Component {...props} /> ) : ( render(props) ) ) : ( <Redirect to={{ pathname: '/auth/login', state: { from: path } }} /> );
      }}
    />
  );
};

export default PrivateRoute;
